ConnectStore = require 'components/enhancers/connect_store'
NMAListActions = require 'actions/nma_list_actions'
NMAListStore = require 'stores/nma_list_store'
NMAQuestionStore = require 'stores/nma_question_store'
QuestionsStore = require 'stores/questions_store'
mediator = require 'mediator'
{ capitalizeFirstLetter } = require 'base/lib/utils'
useTranslation = require 'components/hooks/use_translation'
{
  COMPARISON_ACROSS_OUTCOMES
  OUTCOME_ACROSS_COMPARISONS
  buildComparisonThresholdChartData
  buildOutcomeThresholdChartData
  buildThresholdPlotData
  getRowId
} = require 'lib/threshold_plot_helper'
{
  TableSettingsContext
} = NmaComponents
{ ResponsiveEffectThresholdChart, ThresholdChartSvg } = EpPlots
{ useEffect } = React

storeConnector =
  NMAListStore: (Store) ->
    isFetchingNmaQuestions: Store.isFetching()
    nmaQuestions: Store.getQuestions()
  NMAQuestionStore: (Store) ->
    nmaOutcomes: Store.getOutcomes()
  QuestionsStore: (Store) ->
    regularQuestions: Store.getQuestions()

ThresholdPlot = ({
  comparisonKey
  isFetchingNmaQuestions
  nmaOutcomes
  nmaQuestions
  outcomeId
  plotMode
  qId
  regularQuestions
  renderMode
  includeNetEffect
  selectedComparisonKeys
  selectedOutcomeIds
  sourceType
}) ->
  useEffect(
    ->
      shouldFetch = sourceType is 'nma' and not isFetchingNmaQuestions and
        (nmaQuestions.isEmpty() or nmaOutcomes.isEmpty())
      return undefined unless shouldFetch

      cancelled = false
      _.defer ->
        return if cancelled
        NMAListActions.fetchAllQuestionsAndOutcomes dbId: mediator.project.id

      ->
        cancelled = true
    [sourceType, isFetchingNmaQuestions, nmaQuestions, nmaOutcomes]
  )

  plotData = buildThresholdPlotData {
    sourceType
    qId
    regularQuestions
    nmaQuestions
    nmaOutcomes
  }

  i18n = useTranslation('nma:common_comparator_table')

  unless plotData?.data?.length and plotData.outcomes?.length
    return <div className="threshold-plot-empty">{i18n 'no_data'}</div>

  outcomesToDisplay = if selectedOutcomeIds?.length
    plotData.outcomes.filter (outcome) -> outcome.id in selectedOutcomeIds
  else
    plotData.outcomes

  unless outcomesToDisplay.length
    return <div className="threshold-plot-empty">{i18n 'no_data'}</div>

  settings = _.extend {}, plotData.config,
    outcomes: outcomesToDisplay
    showForestPlotForComparison: true
    showForestPlotForOutcome: true
    thresholdType: plotData.thresholdType
  dataToDisplay = if plotMode is OUTCOME_ACROSS_COMPARISONS and selectedComparisonKeys?.length
    plotData.data.filter (comparison) ->
      getRowId(comparison) in selectedComparisonKeys
  else
    plotData.data

  selectedOutcome = _.find outcomesToDisplay, (outcome) ->
    outcome.id is (outcomeId ? outcomesToDisplay[0]?.id)
  selectedComparison = _.find plotData.data, (comparison) ->
    getRowId(comparison) is comparisonKey
  selectedComparison ?= plotData.data[0]

  comparisonTitle = i18n 'intervention_vs_comparator',
    intervention: selectedComparison.rowElement?.name
    comparator: selectedComparison.comparator?.name
  comparisonChartData = if plotMode isnt OUTCOME_ACROSS_COMPARISONS
    buildComparisonThresholdChartData
      comparison: selectedComparison
      denominator: settings.denominator
      outcomes: outcomesToDisplay
      thresholdMode: plotData.thresholdType
  outcomeChartData = if plotMode is OUTCOME_ACROSS_COMPARISONS and selectedOutcome
    buildOutcomeThresholdChartData
      data: dataToDisplay
      denominator: settings.denominator
      i18next: i18next
      outcome: selectedOutcome
      thresholdMode: plotData.thresholdType
  ChartComponent = if renderMode is 'printout' then ThresholdChartSvg else ResponsiveEffectThresholdChart
  chartProps = if renderMode is 'printout' then { width: 960 } else {}
  chartTitle = if plotMode is OUTCOME_ACROSS_COMPARISONS
    selectedOutcome.name ? ''
  else
    comparisonTitle
  chartTitle = capitalizeFirstLetter chartTitle

  chartData = if plotMode is OUTCOME_ACROSS_COMPARISONS
    outcomeChartData
  else
    comparisonChartData

  <div className="threshold-plot-container">
    {if chartTitle
      <p className="threshold-plot-title">{chartTitle}</p>
    }
    <TableSettingsContext.Provider value={settings}>
      {if chartData
        <ChartComponent
          {...chartProps}
          title=""
          ariaLabel={chartTitle}
          rows={chartData.rows}
          thresholds={chartData.thresholds}
          thresholdMode={plotData.thresholdType}
          renderMode={renderMode}
          valueDomain={chartData.valueDomain}
          showNetEffect={includeNetEffect ? true}
        />
      else
        <div className="threshold-plot-empty">{i18n 'no_data'}</div>
      }
    </TableSettingsContext.Provider>
  </div>

ThresholdPlot.defaultProps =
  plotMode: COMPARISON_ACROSS_OUTCOMES
  renderMode: 'regular'
  sourceType: 'regular'

module.exports = ConnectStore ThresholdPlot,
  [QuestionsStore, NMAListStore, NMAQuestionStore],
  storeConnector
